export const ITEM_STATUSES = [
    { type: 'active', name: 'Доступные' },
    { type: 'archive', name: 'Архивные' },
    { type: 'all', name: 'Все' },
];

